var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profil-container"},[_c('h3',{staticClass:"profil-title"},[_vm._v("Halaman Pengisian Data Vendor")]),_c('p',{staticClass:"profil-subtitle"},[_vm._v("Silahkan mengisi data sesuai kolom di bawah")]),_c('input-form-penilaian',{attrs:{"tables":_vm.tableInput.inputForm1,"listInput":_vm.listInput.inputForm1,"modelName":'addedIUJP',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_iujp',"disabled":_vm.$store.state.k3lStore.is_preview}}),_c('desc-penilaian',{attrs:{"tables":_vm.tableDesc.inputForm1,"listInput":_vm.listDesc.inputForm1,"modelName":'addedIUJP',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_iujp'}}),_c('block-label',{attrs:{"label":'7. SERTIFIKASI SISTEM MANAJEMEN'}}),_c('plain-label',{attrs:{"label":'Berikan keterangan rinci mengenai Sistem Manajemen K3L dan Operasional di perusahaan anda yang sudah mendapatkan sertifikasi atau dinilai/audit oleh pihak ketiga yang terdaftar di badan Akreditasi Nasional/Internasional'}}),_c('div',{staticClass:"vendor-form-wrapper"},[_c('input-fill-form',{attrs:{"label":'Sistem Manajemen',"tables":[
        {
          name: 'Sistem Menajemen/Lingkup Audit',
          obj_name: 'lingkup_audit',
          css: 'column20 mr10 all-column',
          input: false,
          type: '',
        },
        {
          name: 'Organisasi Pihak Ketiga (Lembaga Penerbit Sertifikasi)',
          obj_name: 'third_party',
          css: 'column15 mr10 all-column',
          input: false,
          type: '',
        },
        {
          name: 'Masa Berlaku',
          obj_name: 'masa_berlaku',
          css: 'column10 mr10',
          input: false,
          type: '',
        },
        {
          name: 'Tanggal Efektif',
          obj_name: 'tgl_efektif',
          css: 'column10 mr10',
          input: false,
          type: '',
        },
        {
          name: 'Tangga Berakhir',
          obj_name: 'tgl_berakhir',
          css: 'column15 mr10',
          input: false,
          type: '',
        },
        {
          name: 'Sertifikat',
          obj_name: 'sertifikasi',
          css: 'column15 mr10 all-column',
          input: false,
          type: 'file',
        } ],"isRequired":false,"modalName":'modal_add_sistem_manajemen',"modelName":'addedSistemManajemen',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"operationAdd":'manage_add',"editMutation":'k3lStore/SET_SISTEM_MANAJEMEN',"disabled":true}})],1),_c('plain-label',{attrs:{"label":'Lampirkan daftar dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir)'}}),_c('upload-file',{attrs:{"modelName":'daftarDokumenKerja',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"disabled":true,"docId":25}}),_c('plain-label',{attrs:{"label":'Lampirkan dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir)'}}),_c('upload-file',{attrs:{"modelName":'dokumenKerja',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"disabled":true,"docId":26}}),_c('plain-label',{attrs:{"label":'Lampirkan bukti Pemerikasaan implementasi dokumen kerja (contoh: catatan inspeksi, catatan observasi, catatan hazard report, catatan coaching, dll)'}}),_c('upload-file',{attrs:{"modelName":'pemeriksaanImpelentasiDokumenKerja',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"disabled":true,"docId":27}}),_c('input-form-penilaian',{attrs:{"tables":_vm.tableInput.inputForm2,"listInput":_vm.listInput.inputForm2,"modelName":'addedIUJP',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_iujp',"disabled":_vm.$store.state.k3lStore.is_preview}}),_c('desc-penilaian',{attrs:{"tables":_vm.tableDesc.inputForm2,"listInput":_vm.listDesc.inputForm2,"modelName":'addedIUJP',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_iujp'}}),_c('block-label',{attrs:{"label":'8. KINERJA K3L'}}),_c('plain-label',{attrs:{"label":"Berikan penjelasan rinci mengenai Kinerja K3L serta statistik untuk kerja keselamatan (angka Frequency Rates 'FR' per 1,000,000 jam kerja). *Jumlah kecelakaan berdampak fatality (FT), Major, Minor Injuries, Medical Treatment Injury (MTI), Restricted Working Injury (RWI), First Aid (FA)  "}}),_c('input-area',{attrs:{"storeName":'k3lStore',"modelName":'textGroup8',"mutationName":'k3lStore/SET_K3L_FORM',"disabled":true}}),_c('plain-label',{attrs:{"label":'Lampirkan informasi statistik kinerja K3L serta statistik untuk kerja keselamatan selama 3 Tahun terakhir '}}),_c('upload-file',{attrs:{"modelName":'statistikKinerjaK3L',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"disabled":true,"docId":28}}),_c('plain-label',{attrs:{"label":'Berikan penjelasan bila perusahaan mengalami kecelakaan berdampak LTI (Lost Time Injury) atau pelanggaran lingkungan akibat dari tindakan Perusahaan, Sub-kontraktor anda atau orang lain yang bertindak atas nama Perusahaan anda selama 3 tahun terakhir'}}),_c('input-area',{attrs:{"storeName":'k3lStore',"modelName":'textGroup82',"mutationName":'k3lStore/SET_K3L_FORM',"disabled":true}}),_c('plain-label',{attrs:{"label":'Lampirkan laporan penyelidikan kecelakaan'}}),_c('upload-file',{attrs:{"modelName":'penyelidikanKecelakaan',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"disabled":true,"docId":29}}),_c('block-label',{attrs:{"label":'HASIL PENILAIAN TOTAL'}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 text-bold',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css:
          'column30 col-nohover bg-transparent border-0 text-center text-bold',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    head: [
      {
        title_1: 'MODUL',
        title_2: 'BOBOT NILAI',
        title_3: 'NILAI',
      } ],
    item: [
      {
        type: 'desc',
        desc_1: ['DOKUMEN PERIZINAN PERUSAHAAN'],
        desc_2: ['20%'],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['IUJP / SIUP'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1', 'ITEM 1.2'],
        desc_2: [_vm.bobot_1_1, _vm.bobot_1_2],
        desc_3: [_vm.value_1_1, _vm.value_1_2],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 text-bold',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css:
          'column30 col-nohover bg-transparent border-0 text-center text-bold',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['SUMBER DAYA MANUSIA DAN KOMPETENSI'],
        desc_2: ['15%'],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['KOMPETENSI UMUM'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1'],
        desc_2: [_vm.bobot_2_1],
        desc_3: [_vm.value_2_1],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['KOMPETENSI KHUSUS'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1', 'ITEM 1.2'],
        desc_2: [_vm.bobot_2_2, _vm.bobot_2_3],
        desc_3: [_vm.value_2_2, _vm.value_2_3],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 text-bold',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css:
          'column30 col-nohover bg-transparent border-0 text-center text-bold',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['PENGELOLAAN K3L'],
        desc_2: ['65%'],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['KEBIJAKAN KEPEMIMPINAN & KOMITMEN'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1'],
        desc_2: [_vm.bobot_3_1],
        desc_3: [_vm.value_3_1],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['MANAJEMEN RESIKO'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1', 'ITEM 1.2'],
        desc_2: [_vm.bobot_3_2, _vm.bobot_3_3],
        desc_3: [_vm.value_3_2, _vm.value_3_3],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['MANUAL K3L'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1'],
        desc_2: [_vm.bobot_3_4],
        desc_3: [_vm.value_3_4],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['PENGELOLAAN B3'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1'],
        desc_2: [_vm.bobot_3_5],
        desc_3: [_vm.value_3_5],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['PENGELOLAAN LIMBAH'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1'],
        desc_2: [_vm.bobot_3_6],
        desc_3: [_vm.value_3_6],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1', 'ITEM 1.2'],
        desc_2: [_vm.bobot_3_7, _vm.bobot_3_8],
        desc_3: [_vm.value_3_7, _vm.value_3_8],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['SERTIFIKASI MANAJEMEN'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1', 'ITEM 1.2'],
        desc_2: [_vm.bobot_3_9, _vm.bobot_3_10],
        desc_3: [_vm.value_3_9, _vm.value_3_10],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['KINERJA K3L'],
        desc_2: [],
        desc_3: [],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css: 'column40 col-nohover bg-transparent border-0 px-5',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css: 'column30 col-nohover bg-transparent border-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: ['ITEM 1.1'],
        desc_2: [_vm.bobot_3_11],
        desc_3: [_vm.value_3_11],
      } ],
  } ]}}),_c('desc-penilaian',{attrs:{"tables":[
      {
        title: 'title_1',
        desc: 'desc_1',
        css:
          'column40 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0',
      },
      {
        title: 'title_2',
        desc: 'desc_2',
        css:
          'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
      },
      {
        title: 'title_3',
        desc: 'desc_3',
        css:
          'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
      } ],"listInput":[
  {
    item: [
      {
        type: 'desc',
        desc_1: [''],
        desc_2: ['Total Nilai'],
        desc_3: [
          ((this.total_result) + " - " + (_vm.k3lKplhCategory(
            this.total_result > 0 ? this.total_result : 0
          ))) ],
      } ],
  } ],"modelName":'addedIUJP',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_iujp'}}),_c('div',{staticClass:"profil-btn-wrapper"},[_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Kembali")]),_c('div',{staticClass:"btn-landing",attrs:{"href":""},on:{"click":function($event){return _vm.goNext()}}},[_vm._v(" Simpan & Lanjutkan ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }